import { BriefcaseBase, Briefcase } from './briefcase'
import { CalendarBase, Calendar, CalendarBase2, Calendar2 } from './calendar'
import { CarpoolDriverBase, CarpoolDriver, CarpoolRiderBase, CarpoolRider } from './carpool'
import { ChevronExpandBase, ChevronExpand } from './chevron'
import { ClockBase, Clock } from './clock'
import { DashboardBase, Dashboard } from './dashboard'
import { DotsVerticalBase, DotsVertical } from './dots'
import { DragBase, Drag } from './drag'
import { HomeBase, Home } from './home'
import { InfoCardBase, InfoCard } from './info-card'
import { LockerBase, Locker } from './locker'
import { MailBase, Mail } from './mail'
import {
  MapMarkerPinBase,
  MapMarkerPin,
  MapMarkerPinBase2,
  MapMarkerPin2,
  MapMarkerCircleBase,
  MapMarkerCircle,
  MapMarkerCircleBase2,
  MapMarkerCircle2,
} from './map-marker'
import { MapBase, Map, MapOffBase, MapOff } from './map'
import { MicrosurveyBase, Microsurvey } from './microsurvey'
import { MoneyBase, Money } from './money'
import { NotificationBase, Notification } from './notification'
import { PointBase, Point } from './point'
import { PresentBase, Present, PresentBase2, Present2 } from './present'
import { SocialFacebookBase, SocialFacebook, SocialGoogleBase, SocialGoogle } from './social'
import { StarFillBase, StarFill, StarOutlineBase, StarOutline } from './star'
import { SwapVerticalBase, SwapVertical } from './swap'
import {
  TransitTrainBase,
  TransitTrain,
  TransitBusBase,
  TransitBus,
  TransitSubwayBase,
  TransitSubway,
  TransitTramLightRailBase,
  TransitTramLightRail,
} from './transit'
import {
  TransportBikingBase,
  TransportBiking,
  TransportDrivingBase,
  TransportDriving,
  TransportTransitBase,
  TransportTransit,
  TransportWalkingBase,
  TransportWalking,
} from './transport'
import { UserGroupBase, UserGroup } from './user'
import { WarningBase, Warning } from './warning'

export const Icons = {
  BriefcaseBase,
  Briefcase,

  CalendarBase,
  Calendar,
  CalendarBase2,
  Calendar2,

  CarpoolDriverBase,
  CarpoolDriver,
  CarpoolRiderBase,
  CarpoolRider,

  ChevronExpandBase,
  ChevronExpand,

  ClockBase,
  Clock,

  DashboardBase,
  Dashboard,

  DotsVerticalBase,
  DotsVertical,

  DragBase,
  Drag,

  HomeBase,
  Home,

  InfoCardBase,
  InfoCard,

  LockerBase,
  Locker,

  MailBase,
  Mail,

  MapMarkerPinBase,
  MapMarkerPin,
  MapMarkerPinBase2,
  MapMarkerPin2,
  MapMarkerCircleBase,
  MapMarkerCircle,
  MapMarkerCircleBase2,
  MapMarkerCircle2,

  MapBase,
  Map,
  MapOffBase,
  MapOff,

  MicrosurveyBase,
  Microsurvey,

  MoneyBase,
  Money,

  NotificationBase,
  Notification,

  PointBase,
  Point,

  PresentBase,
  Present,
  PresentBase2,
  Present2,

  SocialFacebookBase,
  SocialFacebook,
  SocialGoogleBase,
  SocialGoogle,

  StarFillBase,
  StarFill,
  StarOutlineBase,
  StarOutline,

  SwapVerticalBase,
  SwapVertical,

  TransitTrainBase,
  TransitTrain,
  TransitBusBase,
  TransitBus,
  TransitSubwayBase,
  TransitSubway,
  TransitTramLightRailBase,
  TransitTramLightRail,

  TransportBikingBase,
  TransportBiking,
  TransportDrivingBase,
  TransportDriving,
  TransportTransitBase,
  TransportTransit,
  TransportWalkingBase,
  TransportWalking,

  UserGroupBase,
  UserGroup,

  WarningBase,
  Warning,
}
